<template>
  <div :class="classModifiers" @click="toggleMobileMenu">
    <div class="hamburger-icon__icon"></div>
  </div>
</template>

<script src="./hamburger-icon.js"></script>
<style src="./hamburger-icon.scss" lang="scss"></style>
